import { useLazyGetAvailableRateGroups } from "@/actions/hooks/useLazyGetAvailableRateGroups.ts";
import { URLParam } from "@/helpers/interfaces/URLParam.ts";
import { useAccommodationTypeURLParams } from "@/pages/AccommodationPicking/hooks/useAccommodationTypeURLParams.ts";
import { useDateURLParams } from "@/pages/AccommodationPicking/hooks/useDateURLParams.ts";
import { useGuestCountURLParams } from "@/pages/AccommodationPicking/hooks/useGuestCountURLParams.ts";
import { useLanguageURLParams } from "@/pages/AccommodationPicking/hooks/useLanguageURLParams.ts";
import { usePaymentResultURLParam } from "@/pages/AccommodationPicking/hooks/usePaymentResultURLParam.ts";
import { useRateGroupURLParams } from "@/pages/AccommodationPicking/hooks/useRateGroupURLParams.ts";
import { useReservationOfferURLParam } from "@/pages/AccommodationPicking/hooks/useReservationOfferURLParam.ts";
import { useEngineStore } from "@/stores/EngineStore/EngineStore.ts";
import format from "date-fns/format";
import i18next from "i18next";
import { useEffect, useState } from "react";
import { useShallow } from "zustand/react/shallow";

export const useURLParams = () => {
  const [initialFetchDone, setInitialFetchDone] = useState(false);
  const { defaultDateRange, defaultAdults } = useEngineStore(
    useShallow((state) => ({ defaultDateRange: state.defaultDateRange, defaultAdults: state.defaultAdults })),
  );
  const { handleInitialFetchAvailableRGs } = useLazyGetAvailableRateGroups();

  useDateURLParams();
  useGuestCountURLParams();
  useLanguageURLParams();
  useRateGroupURLParams();
  useAccommodationTypeURLParams();
  usePaymentResultURLParam();
  const { reservationOfferLoading } = useReservationOfferURLParam();

  // changes URL params on state change
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const [startDate, endDate] = defaultDateRange;

    if (startDate !== null && isFinite(+startDate) && endDate !== null && isFinite(+endDate)) {
      urlParams.set(URLParam.StartDate, format(new Date(startDate), "yyyy-MM-dd"));
      urlParams.set(URLParam.EndDate, format(new Date(endDate), "yyyy-MM-dd"));
    }

    if (defaultAdults) {
      urlParams.set(URLParam.GuestCount, defaultAdults.toString());
    }

    if (i18next.language) {
      urlParams.set(URLParam.Language, i18next.language);
    }

    if (urlParams.toString() === "") return;

    window.history.replaceState({}, "", `?${urlParams.toString()}`);

    // fetches initial data if URL params are NOT present
    if (!initialFetchDone) {
      void handleInitialFetchAvailableRGs();
      setInitialFetchDone(true);
    }
  }, [defaultDateRange, defaultAdults, handleInitialFetchAvailableRGs, initialFetchDone]);

  return { reservationOfferLoading };
};
